import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./service.scss";


// Components
import Sponsorship from "./Sponsorship";
import Branding from "./Branding";
import TVMedia from "./TVMedia";

import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/person02.png";

const service = () => (
  <div className="service" id="service">
    <div className="wrapper">
      <Title title="OUR SERVICES" />
      <p className="font12">

<br></br>
      </p>
      <center>
      <Row className="g-4">
        <Col md={4} lg={4}>
        <Sponsorship />
        </Col>
        <Col md={6} lg={4}>
          <Branding />
        </Col>

        <Col md={6} lg={4}>
          <TVMedia />
        </Col>
       
      </Row>
     </center>
    </div>
  </div>
);

export default service;
